import { rejectTenderApplicationDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const rejectTenderApplicationCallable = getCallable(
  rejectTenderApplicationDefinition,
);
